import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useDashboard } from '../../context/DashboardContext';
import { useTranslation } from 'react-i18next';

const WeeklySummary: React.FC = () => {
  const { isDark } = useTheme();
  const { weeklyData, totalHoursThisWeek } = useDashboard();
  const { t } = useTranslation();

  const widgetBg = isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200';
  const textColor = isDark ? 'text-white' : 'text-slate-900';
  const mutedText = isDark ? 'text-slate-400' : 'text-slate-600';
  const headerBg = isDark ? 'bg-slate-700' : 'bg-slate-50';

  const goalTotal = 40;
  const progressPercent = Math.min(100, (totalHoursThisWeek / goalTotal) * 100);

  return (
    <div className={`rounded-lg border p-6 ${widgetBg}`}>
      <h2 className={`text-lg font-semibold mb-4 ${textColor}`}>{t('dashboard.thisWeek')}</h2>

      <div className="mb-6">
        <div className="flex justify-between items-baseline mb-2">
          <span className={`text-sm font-medium ${mutedText}`}>{t('dashboard.totalHours')}</span>
          <span className={`text-2xl font-bold ${textColor}`}>
            {totalHoursThisWeek.toFixed(1)}h / {goalTotal}h
          </span>
        </div>
        <div className={`w-full h-3 rounded-full ${isDark ? 'bg-slate-700' : 'bg-slate-200'} overflow-hidden`}>
          <div
            className="h-full bg-blue-500 transition-all duration-300"
            style={{ width: `${progressPercent}%` }}
          ></div>
        </div>
      </div>

      <div className="space-y-2">
        {weeklyData.map(day => (
          <div
            key={day.date}
            className={`flex items-center justify-between p-3 rounded-lg ${headerBg}`}
          >
            <div className="flex-1">
              <div className={`text-sm font-medium ${textColor}`}>{day.day}</div>
              <div className={`text-xs ${mutedText}`}>{day.date}</div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-32 h-2 rounded-full bg-slate-600/30 overflow-hidden">
                <div
                  className={`h-full ${day.totalHours >= day.goalHours ? 'bg-green-500' : 'bg-amber-500'}`}
                  style={{ width: `${Math.min(100, (day.totalHours / day.goalHours) * 100)}%` }}
                ></div>
              </div>
              <div className={`text-sm font-medium text-right min-w-max ${textColor}`}>
                {day.totalHours.toFixed(1)}h
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklySummary;
